import { render, staticRenderFns } from "./PwdResetSendComplete.vue?vue&type=template&id=6237fcc0&"
import script from "./PwdResetSendComplete.vue?vue&type=script&lang=ts&"
export * from "./PwdResetSendComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports